import { ComponentConfigurationClass } from "@zoovu/runner-browser-api";
import { ConfigurationValues, ValuesConfigurationConstructor } from "./values";
import { Attribute } from "./attribute";

export interface PriceSettings {
    showAdditionalText: boolean;
    textPlacements: TextPlacements;
}

export interface TextPlacements {
    right: TextPlacementItem;
    left: TextPlacementItem;
    top: TextPlacementItem;
    bottom: TextPlacementItem;
}

export interface TextPlacementItem {
    label?: string;
    labelButton?: string;
    labelColumn?: string;
    text?: string;
    column?: Attribute;
    isPrice?: boolean;
    isReversed?: boolean;
}

/**
 * @title Price Configuration
 * @additionalProperties false
 */
@ValuesConfigurationConstructor(ConfigurationValues.Price)
@ComponentConfigurationClass("price")
export class PriceConfiguration {
    /**
     * @description Add complementary text|Use the fields below to enrich your product price with complementary information|Give your customers additional information on the price they'll pay, e.g. by saying it includes VAT or it's a time-limited offer.
     * @format custom-price
     */
    public settings?: PriceSettings;
}
